import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';
import bugsnagHandler from '../../services/bugsnag.service';

export interface IAchOutFees {
  expirationDate: Date;
  feeDescription: string;
  fees: [{ achTransferType: string; arrivalDate: string; arrivalDateShort: string; fee: number }];
}

interface IProps {
  customerId: string;
  accountExternalId: string;
  amount: string;
  onSuccess: (data: IAchOutFees) => void;
}

export const useAchOutFeesQuery = ({ customerId, accountExternalId, amount, onSuccess }: IProps) =>
  useQuery(
    'ach-out-fees',
    async () => {
      const { data } = await httpService.get(
        `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/ach/out/fees?amount=${amount}`,
      );
      return data;
    },
    {
      enabled: false,
      cacheTime: 10,
      onSuccess: (data: IAchOutFees) => {
        onSuccess(data);
      },
      onError: (data: IServerErrorResponse) => {
        bugsnagHandler.notify(
          `Failed to fetch ach out fees for customerId: ${customerId} with the error: ${data?.response?.data?.errors?.[0]?.message || ''}`,
        );
      },
    },
  );
